import { reactive } from 'vue'

const state = reactive({ show: false, feature: null })

const COPY = {
  'ai-cover-letter': {
    icon: 'fa-wand-magic-sparkles',
    title: 'AI Cover Letters',
    message: "You've used all your AI cover letters. Upgrade for more.",
    benefits: [
      { icon: 'fa-bolt', text: 'More AI cover letters every month' },
      { icon: 'fa-bullseye', text: 'Tailored to each job post automatically' },
      { icon: 'fa-envelope-open-text', text: 'Higher chance of getting a reply' },
    ],
  },
  'filter-preset': {
    icon: 'fa-filter',
    title: 'Job Filter Presets',
    message: "You've reached your filter preset limit. Upgrade to add more.",
    benefits: [
      { icon: 'fa-sliders', text: 'More active filters running at once' },
      { icon: 'fa-bell', text: 'Get alerts for more job types simultaneously' },
      { icon: 'fa-magnifying-glass', text: 'Find niche roles other applicants miss' },
    ],
  },
  'email-alerts': {
    icon: 'fa-bell',
    title: 'Email Job Alerts',
    message: 'Upgrade for faster email alerts — daily or even instantly, straight to your inbox.',
    benefits: [
      { icon: 'fa-filter', text: 'Only jobs that match your filters — no noise' },
      { icon: 'fa-envelope', text: 'Daily or instant alerts, straight to your email' },
      { icon: 'fa-rotate', text: 'Set it once and stay updated automatically' },
    ],
  },
}

export function useUpgradeModal() {
  function openModal(feature) {
    state.feature = feature
    state.show = true
  }
  function closeModal() {
    state.show = false
    state.feature = null
  }
  function getCopy() {
    return COPY[state.feature] ?? null
  }
  return { state, openModal, closeModal, getCopy }
}
